export const PX_2 = '2px';
export const PX_5 = '5px';
export const PX_6 = '6px';
